import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import sortBy from 'lodash/sortBy';
import './search.m.css';
//import { getLoadMoreStories } from "../utils";
import ImageType2 from "../molecules/image-type-2";
import { SearchBox } from "../atoms/search-box";
import ImageType3 from "../molecules/image-type-3";

const SearchPage = (props) => {
  const { total,query } = props.data;
  // will be getting initially 9 stories, but showing only 8 for loadmore functionality
  //const [storiesToRender, setStoriesToRender] = useState(8);
  //const [stories, setStories] = useState(props.data.stories);
  const [orderedStories, setOrderedStories] = useState([]);
  const [queryValue, setQueryValue] = useState("");

    useEffect(() => {
      if(typeof window !== "undefined"){
        const currentUrl = window.location.href;
        // Check if 'search?q=' exists in the URL
        const searchQuery = "search?q=";
        if (currentUrl.includes(searchQuery)) {
          const urlParams = new URLSearchParams(window.location.search);
          const query = urlParams.get("q"); // Extract 'q' parameter value
          if (query) {
            setQueryValue(query);
          }
        }
      }

    }, []);

  useEffect(() => {
    const callAPI = async () => {
      const stories = await fetch(`/api/v1/advanced-search?q=${queryValue}&limit=300`)
      const response = await stories.json();
      const res = response.items;
     /* const ordered = sortBy(res, [function (o) {
        return o["published-at"];
      }])
      const resultData = ordered.reverse();*/
      setOrderedStories(res);
    }
    callAPI();
  }, [queryValue])
/*
  const collection = {
    items: stories.slice(0, storiesToRender),
  };*/
/*
  const getMoreStories = async (offset, limit) => {
    await getLoadMoreStories({
      offset: offset,
      limit: limit,
      isSearchPage: true,
      slug: props.data.query,
      setStories: setStories,
      storiesToRender: storiesToRender,
      setStoriesToRender: setStoriesToRender,
      stories: stories,
    });
  };*/
  return (
    <React.Fragment>
      <h2 styleName="search-results">
        Haku - {query} ({total} tulosta)
      </h2>
    <div className="" styleName="search-wrapper">
     {/* <div style={{border:'1px solid red'}}>
      <SearchBox />
      </div>*/}
      {orderedStories.map((story)=>
      <div index={story.id}>
         <ImageType3
           story={story}
           showDateSection={false}
           isSearchPage={true}
        />
      </div>
      )}
    </div>
    </React.Fragment>
  );
};

SearchPage.propTypes = {
  data: PropTypes.object,
};

export { SearchPage };
